module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "arrow-left-collapse-expand.cd6f89d0.svg";